define([
    '../Util/defined',
    '../System/Vec3Obj',
    '../Enum/EnumAltitudeMode',
], function (
    defined,
    Vec3Obj,
    EnumAltitudeMode,
) {
    'use strict';

    /**
     * 矢量线符号。
     * <br /><br />
     * <div align='center'>
     * <img src='images/PolylineSymbol.png' width='900' height='650' /><br />
        * 矢量线符号效果图
     * </div>
     * 
     * @demo {@link http://lbs.zjkelan.com/PolylineSymbol.html|CooWasm PolylineSymbol demo}
     * @alias PolylineSymbol
     * @constructor
     *
     * @param {Object} props 包含如下属性的Object：
     * @param {EnumAltitudeMode} [props.altitudeMode=EnumAltitudeMode.CLAMP] 高程模式。
     * @param {Number} [props.altitude=0.0] 高程值，单位：米。当altitudeMode为EnumAltitudeMode.CLAMP时不生效。
     * @param {Number} [props.minDistance=200.0] 最小可视距离。
     * @param {Number} [props.maxDistance=50000.0] 最大可视距离。
     * @param {ColorObj|String} [props.lineColor="#FFFFFF"] 线颜色，可以是ColorObj对象或十六进制颜色字符串(如"#FFFFFF")。
     * @param {Number} [props.lineAlpha=1.0] 线透明度，范围0.0-1.0。
     * @param {Number} [props.lineWidth=2.0] 线宽度，单位:像素。
     * @param {ColorObj|String} [props.outlineColor="#000000"] 轮廓线颜色，可以是ColorObj对象或十六进制颜色字符串(如"#000000")。
     * @param {Number} [props.outlineAlpha=1.0] 轮廓线透明度，范围0.0-1.0。
     * @example
     * var icon = new CooWasm.PolylineSymbol({});
     */
    class PolylineSymbol {
        /**
         * @description 高程模式。
         * @type {EnumAltitudeMode}
         */
        altitudeMode
        /**
         * @description 高程值，单位：米。当altitudeMode为EnumAltitudeMode.CLAMP时不生效。
         * @type {Number}
         */
        altitude
        /**
         * @description 最小可视距离。
         * @type {Number}
         */
        minDistance
        /**
         * @description 最大可视距离。
         * @type {Number}
         */
        maxDistance
        /**
         * @description 线颜色，可以是ColorObj对象或十六进制颜色字符串(如"#FFFFFF")。
         * @type {ColorObj|String}
         */
        lineColor
        /**
         * @description 线透明度，范围0.0-1.0。
         * @type {Number}
         */
        lineAlpha
        /**
         * @description 线宽度，单位:像素。
         * @type {Number}
         */
        lineWidth
        /**
         * @description 轮廓线颜色，可以是ColorObj对象或十六进制颜色字符串(如"#000000")。
         * @type {ColorObj|String}
         */
        outlineColor
        /**
         * @description 轮廓线透明度，范围0.0-1.0。
         * @type {Number}
         */
        outlineAlpha
        /**
         * @description 属性信息。
         * @private
         * @readonly
         */
        properties = ""
        /**
         * @description PolylineSymbol在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "PolylineSymbol"

        constructor(props) {
            if (!defined(props)) {
                props = {}
            }
            this.properties += this.toStr("altitudeMode", props.altitudeMode, "AltitudeMode")
            this.properties += this.toStr("altitude", props.altitude, "Altitude")
            this.properties += this.toStr("minDistance", props.minDistance, "MinVisibleDistance")
            this.properties += this.toStr("maxDistance", props.maxDistance, "MaxVisibleDistance")
            this.properties += this.toStr("lineColor", props.lineColor, "LineColor")
            this.properties += this.toStr("lineAlpha", props.lineAlpha, "LineTransparency")
            this.properties += this.toStr("lineWidth", props.lineWidth, "LineWidth")
            this.properties += this.toStr("outlineColor", props.outlineColor, "OutlineColor")
            this.properties += this.toStr("outlineAlpha", props.outlineAlpha, "OutlineTransparency")
        }

        toStr(memName, value, key) {
            let result = ""
            if (defined(value)) {
                this[memName] = value
                if (typeof value.toStr === 'function') {
                    result = key + ":" + value.toStr() + "|"
                } else {
                    result = key + ":" + value + "|"
                }
            }
            return result
        }
        
        update(symbol) {
            let componentProps = ""
            if (!defined(symbol)) {
                return componentProps
            }
            if (defined(symbol.altitudeMode)) {
                this.altitudeMode = symbol.altitudeMode
                componentProps += "AltitudeMode:" + this.altitudeMode + "|"
            }
            if (defined(symbol.altitude)) {
                this.altitude = symbol.altitude
                componentProps += "Altitude:" + this.altitude + "|"
            }
            if (defined(symbol.minDistance)) {
                this.minDistance = symbol.minDistance
                componentProps += "MinVisibleDistance:" + this.minDistance + "|"
            }
            if (defined(symbol.maxDistance)) {
                this.maxDistance = symbol.maxDistance
                componentProps += "MaxVisibleDistance:" + this.maxDistance + "|"
            }
            if (defined(symbol.lineColor)) {
                this.lineColor = symbol.lineColor
                componentProps += "LineColor:" + this.lineColor + "|"
            }
            if (defined(symbol.lineAlpha)) {
                this.lineAlpha = symbol.lineAlpha
                componentProps += "LineTransparency:" + this.lineAlpha + "|"
            }
            if (defined(symbol.lineWidth)) {
                this.lineWidth = symbol.lineWidth
                componentProps += "LineWidth:" + this.lineWidth + "|"
            }
            if (defined(symbol.outlineColor)) {
                this.outlineColor = symbol.outlineColor
                componentProps += "OutlineColor:" + this.outlineColor + "|"
            }
            if (defined(symbol.outlineAlpha)) {
                this.outlineAlpha = symbol.outlineAlpha
                componentProps += "OutlineTransparency:" + this.outlineAlpha + "|"
            }
            return componentProps
        }
    }
    return PolylineSymbol
})